import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss'
})
export class IconComponent {
  
  @Input() name: string = '';
  @Input() size: number = 24;
  @Input() class: string = '';
  @Input() strokeWidth: number = 2;
}
